import { render, staticRenderFns } from "./videoBox.vue?vue&type=template&id=7bbeb7e8&scoped=true"
import script from "./videoBox.vue?vue&type=script&lang=js"
export * from "./videoBox.vue?vue&type=script&lang=js"
import style0 from "./videoBox.vue?vue&type=style&index=0&id=7bbeb7e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbeb7e8",
  null
  
)

export default component.exports